import { Button } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { MAIN_PATH } from '../../../constant/Constant';

const Page404View = () => {
    let navigate = useNavigate();

    const goBackHandler = () => {
        navigate(-1);
    };

    const goHomeHandler = () => {
        navigate(MAIN_PATH);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='error-pg'>
                    <span className='error-img'></span>
                    <div className='error-txt'>
                        죄송합니다.
                        <br />
                        요청하신 페이지를 찾을 수 없습니다.
                    </div>
                    <p className='error-detail-txt'>
                        방문하려는 페이지의 주소가 잘못 입력되었거나, 페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수 없습니다.
                        <br />
                        입력하신 주소가 정확한지 다시 한 번 확인해 주시기 바랍니다.
                        <br />
                        감사합니다.
                    </p>
                    <div className='error-btn-wrap btn-wrap'>
                        <button type='button' className='btn negative' onClick={() => goHomeHandler()}>
                            메인으로 이동
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Page404View;
